<template>
  <div class="reportTable">
    <!-- F10 -->
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>
              {{ this.$moment(this.startDate).format("YYYY-MM-DD") }}
            </span>
            <span v-if="$parent.endTimeShow">
              至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}
            </span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
        </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>

      <div class="report">
        <div class="form-content">
          <ul class="PreArrivalItem" style="font-weight:bold">
            <!-- <li style="width: 90px">序号</li> -->
            <div>账号</div>
            <div>宾客名称</div>
            <div>房号</div>
            <div>到店时间</div>
            <div>离店时间</div>
            <div>状态</div>
            <div>收银员</div>
            <div>加收类型</div>
            <div style="text-align:right">应收金额</div>
          </ul>
        </div>
        <div class="formContaniner">
          <transition-group name="registeredList" tag="p">
            <div
              class="PreArrivalItem"
              v-for="(item, index) in preArrivalList"
              :key="index"
            >
              <div>{{ item.accNo }}</div>
              <div>{{ item.guestName }}</div>
              <div>{{ item.roomNo }}</div>
              <div>{{ item.arrTime }}</div>
              <div>{{ item.checkOutTime }}</div>
              <div>
                <span v-if="item.status == 'R'">预定</span>
                <span v-if="item.status == 'I'">入住</span>
                <span v-if="item.status == 'O'">离店</span>
                <span v-if="item.status == 'C'">取消</span>
                <span v-if="item.status == 'N'">未到</span>
                <span v-if="item.status == 'S'">悬单</span>
                <span v-if="item.status == 'D'">删除</span>
              </div>
              <div>{{ item.operator }}</div>
              <div>
                <span v-if="item.audi == 1">半天</span>
                <span v-else>全天</span>
              </div>
              <div style="text-align:right">{{ item.amount.toFixed(2) }}</div>
            </div>
          </transition-group>
        </div>
        <div class="c30-foot" style="border: none">
          <div class="c30-foot-con1">
            <div style="width: 50%">合计：</div>
            <div>{{ preArrivalList.length }}条记录</div>
          </div>
          <div>应收金额:{{ total.toFixed(2) }}</div>
          <div></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
import { time } from "echarts";
export default {
  data() {
    return {
      // 本日预到的宾客表
      preArrivalList: [],
      // 已经登记宾客表
      registeredList: [],
      // 今日在店宾客报表
      inStoreTitleList: [],
      queryDate: "",
      total: 0,
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "U17.客房全天/半天房费稽核";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    //把所有搜索都隐藏
    this.$parent.closeshow();
    // this.$parent.isShow2 = false;
    //显示需要用的搜索
    this.$parent.startTimeShow = true;
    this.$parent.chaxunvib = true;
    // this.$parent.endTimeShow = true;
    this.getPreArrivalList();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    dateChange(data) {
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    doserach() {
      this.getPreArrivalList();
    },
    getPreArrivalList() {
      this.preArrivalList=[];
      this.total=0;
      let that = this;
      let postparm = {
        searchTime: this.$parent.startDate,
      };
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/report/U17", postparm).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          res.data.forEach((timeItem) => {
            this.total += timeItem.amount;
            timeItem.arrTime = this.$moment(timeItem.arrTime).format(
              "YYYY-MM-DD "
            );
            timeItem.checkOutTime = this.$moment(timeItem.checkOutTime).format(
              "YYYY-MM-DD "
            );
          });
          this.preArrivalList = res.data;
          this.$store.state.preArrivalList = res.data;
          this.$store.state.preArrivalName = "U17.客房全天/半天房费稽核";
          that.$parent.datacount = res.data.length;
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.formTitle > li {
  width: 8em;
  text-align: center;
}
.formContaniner {
  border-bottom: 2px solid black;
}
.c30-foot {
  display: flex;
  font-size: 14px;
  align-items: center;
  width: 100%;
  border-bottom: 2px solid black;
  font-weight: 500;
  font-weight: 600;
}
.c30-foot .c30-foot-con1 {
  display: flex;
  align-items: center;
  width: 73% !important;
  padding-left: 15%;
}
.c30-foot .c30-foot-con1 > div {
  display: flex;
  width: 20%;
}
.c30-foot > div {
  width: 17% ;
  text-align: center;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
.PreArrivalItem>div{
  flex:1
}
</style>